import { render, staticRenderFns } from "./OutStandingPaymentsView.vue?vue&type=template&id=c04f2b64&scoped=true"
import script from "./OutStandingPaymentsView.vue?vue&type=script&lang=js"
export * from "./OutStandingPaymentsView.vue?vue&type=script&lang=js"
import style0 from "./OutStandingPaymentsView.vue?vue&type=style&index=0&id=c04f2b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04f2b64",
  null
  
)

export default component.exports